import styled from "@emotion/styled";
import { PRIMARY_BLUE, HEADING } from "src/constants/colors";

export const EmailHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 2fr 1.5fr 1fr;
  gap: 16px;
  padding: 0px 25px;
  max-height: 52px;
  background-color: transparent;
`;

export const EmailRow = styled.div<{ isSelected?: boolean }>`
  display: grid;
  grid-template-columns: 1.5fr 2fr 1.5fr 1fr;
  gap: 16px;
  height: 66px;
  padding: 0px 25px;
  cursor: pointer;
  transition: background-color 0.2s;
  background: ${({ isSelected }) =>
    isSelected ? PRIMARY_BLUE + "10" : "transparent"};

  &:hover {
    background: ${({ isSelected }) =>
      isSelected ? PRIMARY_BLUE + "15" : "rgba(250, 251, 252, 1)"};
  }
`;

export const EmailCell = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${HEADING};
  word-break: break-word;
`;
